<template>
  <div class="m--skin-login" style="height: 100%">
    <header>
      <div class="m-header__top t3-header"></div>
    </header>
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
        id="m_login">
        <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
          <div class="m-login__container">
            <div class="m-login__signup" style="display: block">
              <div class="m-login__head">
                <h3 class="m-login__title">Register</h3>
                <div class="m-login__desc">
                  Enter your details to create your account:
                </div>
              </div>
              <div class="m-login__form m-form">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group m-form__group" :class="{'has-danger': errors.has('firstName') }">
                      <input type="text" class="form-control m-input" id="firstName" name="firstName" v-validate="'required'" data-vv-as="first name" v-model='user.firstName' placeholder="First Name" />
                      <small v-show="errors.has('firstName')" class="form-control-feedback">{{ errors.first('firstName') }}</small>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group m-form__group" :class="{'has-danger': errors.has('lastName') }">
                      <input type="text" class="form-control m-input" id="lastName" name="lastName" v-validate="'required'" data-vv-as="last name" v-model="user.lastName" placeholder="Last Name" />
                      <small v-show="errors.has('lastName')" class="form-control-feedback">{{ errors.first('lastName') }}</small>

                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group m-form__group" :class="{'has-danger': errors.has('idNo') }">
                      <input type="text" class="form-control m-input" id="idNo" name="idNo" v-validate="{ required: true, regex: /[a-zA-Z0-9/-]+$/ , min:7 , max: 12}" data-vv-as="ID number" v-model="user.idNo" placeholder="ID Number" />
                      <small v-show="errors.has('idNo')" class="form-control-feedback">{{ errors.first('idNo') }}</small>

                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group m-form__group" :class="{'has-danger': errors.has('phoneNo') }">
                      <input type="text" class="form-control m-input" id="phoneNo" name="phoneNo" v-validate="'required|digits:10'" data-vv-as="phone number" v-model="user.phoneNo" placeholder="Mobile Number" />
                      <small v-show="errors.has('phoneNo')" class="form-control-feedback">{{ errors.first('phoneNo') }}</small>
                      <span v-show="errors.has('phoneNo')" class="form-control-feedback" aria-hidden="true">
                      <i class="icon md-close" aria-hidden="true"></i>
                    </span>
                    </div>
                  </div>
                </div>


                <div class="form-group m-form__group" :class="{'has-danger': errors.has('email') }">
                  <input type="email" class="form-control m-input" id="email" name="email" v-validate="'required|email'" placeholder="Email" v-model="user.email" />
                  <small v-show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</small>

                </div>


                <div class="form-group m-form__group" :class="{'has-danger': errors.has('password') }">
                  <input type="password" class="form-control m-input" id="password" name="password" v-validate="'required|min:8'"
                         v-model="user.password" placeholder="Password" ref="password" />
                  <small v-show="errors.has('password')" class="form-control-feedback">{{ errors.first('password') }}</small>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger': errors.has('confirmPassword') }">
                  <input type="password" v-validate="'confirmed:password'" data-vv-as="password" class="form-control m-input" name="confirmPassword" placeholder="Confirm Password" />
                  <small v-show="errors.has('confirmPassword')" class="form-control-feedback">{{ errors.first('confirmPassword') }}</small>
                </div>
                <div class="m-login__form-action">
                  <button @click="signUp" class="btn btn-custome-login btn-block m-btn- m-btn--custom m-btn--air m-login__btn m-login__btn--custome">
                    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                    <span v-else>Register</span>
                  </button>
                  <!--<router-link to="/" id="m_login_signup_cancel" class="btn btn-outline-focus  m-btn m-btn&#45;&#45;pill m-btn&#45;&#45;custom">-->
                    <!--Cancel-->
                  <!--</router-link>-->
                </div>
                <div class="m-login__account m--margin-top-20">
                  <span class="m-login__account-msg">Have an accout ?</span>&nbsp;&nbsp;
                  <router-link to="/" id="m_login_signup" class="m-link m-link--light m-login__account-link">
                    log in
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../api";
import helper from "../../helpers";
import Welcome from "../partials/Welcome";

export default {
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      user: {
        firstName: "",
        lastName: "",
        email: "",
        idNo: "",
        phoneNo: "",
        password: ""
      }
    };
  },
  components: {
    welcome: Welcome
  },
  methods: {
    signUp() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (valid) {
            const txType = "sign-up";
            this.toggleLoading();
            api
              .request(txType, this.user)
              .then(response => {
                let data = response.data;
                if (data.status === "00") {
                  this.toggleLoading();
                  const message =
                    "Please check your mobile phone for the verification code.";
                  helper.successAlert(message).then(() => {
                    this.$store.commit("SET_USER", data.user);
                    this.$store.commit("SET_CONFIRM_TOKEN", data.token);

                    if (window.localStorage) {
                      window.localStorage.setItem(
                        "user",
                        JSON.stringify(data.user)
                      );
                      window.localStorage.setItem("confirm_token", data.token);
                    }
                    this.$router.push("confirm");
                  });
                } else {
                  this.toggleLoading();
                  helper.errorAlert(data.message);
                }
              })
              .catch(error => {
                this.toggleLoading();
                helper.errorAlert(
                  "Sorry, we are unable to sign you up at this time. Please try again later."
                );
                console.log(error);
              });
          }
        })
        .catch(() => {
          console.log("Validations failed");
        });
    },
    toggleLoading() {
      this.loading = this.loading ? false : true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUp.vue